<template>
  <div>
    <login-component> </login-component> 

  </div>
</template>
<script>
    import loginComponent from '@/components/loginComponent/PxLogin.vue'
    
    export default {
        name:'Login',
        components:{
          loginComponent
        },
        data(){
            return{}
        },
        methods:{},
        created() {},
    }
</script>
